import { doorClient, resolve, leyanbotClient } from 'services/api';

// 新增自定义单品
export const createCustomClass = (data: Knowledge.SingleClass.CreateCustomClassParams) => {
  return resolve<{ id: number }>(
    leyanbotClient.post('/oversea-knowledge/spu_knowledges/v3/spu_class', data),
  );
};

// 绑定官方单品
export const bindOfficialClass = (data: Knowledge.SingleClass.BindOfficialClassParams) => {
  return doorClient.put('/knowledge/spu_knowledges/spu_class/spus', data);
};

// 更新自定义单品
export const updateCustomClass = (
  data: Knowledge.SingleClass.CreateCustomClassParams & { spuClassId: number },
) => {
  return doorClient.put('/knowledge/spu_knowledges/spu_class/update', data);
};

// 删除自定义单品
export const deleteCustomClass = (spuClassId: number) => {
  return doorClient.delete(`/knowledge/spu_knowledges/spu_class/delete?spuClassId=${spuClassId}`);
};

// 单品类目列表
export const getDomainList = () => {
  return resolve<Knowledge.SingleClass.DomainList>(
    doorClient.get('/knowledge/spu_knowledges/domain_spu_class'),
  );
};

// 高销量单品列表
export const getHighSalesList = (params: { pageNo: number; pageSize: number }) => {
  return doorClient
    .get<{
      data: Knowledge.SingleClass.HighSalesList;
      page: {
        total: number;
      };
    }>('/knowledge/top_sale_spus', { params })
    .then((res) => {
      return res.data;
    });
};

// 更换spu的单品
export const changeSpuClass = (data: {
  spus: Knowledge.SPU.Spu[];
  newSpuClassId: number;
  oldSpuClassId: number;
}) => {
  return doorClient.put('/knowledge/spu_class_mapping/update', data);
};
